<template>
	<v-container>
		<v-row>
			<v-col cols="12">
				<v-col>
					<p class="title">Email Template</p>
				</v-col>
				<!-- <v-col>

					<div>
						<p>Email Template To Send Along With Options</p>
					</div>
					
				</v-col> -->
				<v-card>
					<v-card-text>
						<v-container>
							<v-row>
								<v-col cols="12">
									<p>Email Message To Send Along With Options:</p>
									<v-textarea outlined counter="500" text-capitalize v-model="message" maxlength="500" label="Email Message"></v-textarea>
								</v-col>
							</v-row>
						</v-container>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'EmailLayout',
	components: {

	},
	data(){
		return {

		}
	},
	computed: {
		message: {
			set(message){
				this.$store.commit('emailMessage', message)
			},
			get(){
				return this.$store.state.company.emailMessage
			}
		}
	},
	methods: {
		
	}

}
</script>
<style type="text/css" scoped>
</style>